export default "<div class=\"chip\" [ngClass]=\"chipClass\">\n  <ng-content></ng-content>\n</div>\n";